// hooks/useEchoWhenConnected.ts
import { useEffect } from 'react';
import echo from '../services/echo'; // echo init file

export const useEchoWhenConnected = (onConnected: () => void) => {
  useEffect(() => {
    const connection = echo.connector.pusher.connection;

    if (connection.state === 'connected') {
      // Already connected — immediately call
      onConnected();
    } else {
      // Wait for connection to be established
      const handleConnect = () => {
        onConnected();
      };

      connection.bind('connected', handleConnect);

      return () => {
        connection.unbind('connected', handleConnect);
      };
    }
  }, []);
};
